module.exports = __webpack_public_path__ + "img/Image16.5791c107.jpg";